<template>
  <FormItem :label-width="labelWidth" :label="label" v-if="game">
    <auto-complete
      :data="gameData"
      v-model="gameId"
      :width="width"
      :size="size"
      :disabled="disabled"
      :placeholder="placeholder || '全部'"
      @on-select="handleEvent"
    ></auto-complete>
  </FormItem>
  <FormItem :label-width="labelWidth" :label="label" v-else-if="ptom">
    <auto-complete
      :data="ptomData"
      v-model="ptomId"
      :width="width"
      :size="size"
      :disabled="disabled"
      :placeholder="placeholder"
      @on-select="handleEvent"
    ></auto-complete>
  </FormItem>
  <FormItem :label-width="labelWidth" :label="label" v-else-if="member">
    <auto-complete
      :data="opData"
      v-model="opId"
      :width="width"
      :size="size"
      :disabled="disabled"
      :placeholder="placeholder"
      @on-select="handleEvent"
    ></auto-complete>
  </FormItem>
  <FormItem :label-width="labelWidth" :label="label" v-else-if="media">
    <auto-complete
      :data="mediaData"
      v-model="mediaId"
      :width="width"
      :size="size"
      :disabled="disabled"
      :placeholder="placeholder"
      @on-select="handleEvent"
    ></auto-complete>
  </FormItem>
  <FormItem :label-width="labelWidth" :label="label" v-else-if="group">
    <auto-complete
      :data="groupData"
      v-model="groupId"
      :width="width"
      :size="size"
      :disabled="disabled"
      :placeholder="placeholder"
      @on-select="handleEvent"
    ></auto-complete>
  </FormItem>
  <FormItem :label-width="labelWidth" :label="label" v-else-if="account">
    <auto-complete
      :data="accountData"
      v-model="accountId"
      :width="width"
      :size="size"
      :disabled="disabled"
      :placeholder="placeholder"
      @on-select="handleEvent"
    ></auto-complete>
  </FormItem>
  <FormItem :label-width="labelWidth" :label="label" v-else-if="labels">
    <el-select
      ref="multSelect"
      v-model="labelIds"
      multiple
      filterable
      collapse-tags
      :popper-append-to-body="false"
      :size="size"
      :disabled="disabled"
      :style="{ width: `${width}px` }"
      :placeholder="placeholder"
    >
      <el-option v-for="item in labelData" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </FormItem>
</template>
<script>
import AutoComplete from '@/components/autocomplete/autocomplete'
import { isArray } from '@/common/js/utils' // , debounce
import { getPtomGroupGames } from '@/api/material.model'
import { adGames, adPtom, getCaoHuaOpenIds, getSysMedia, adAccount, getSysTag } from '@/api/common.model'
export default {
  name: 'idropDown',
  components: { AutoComplete },
  props: {
    value: {
      type: [Number, String, Boolean],
      default: ''
    },
    label: {
      type: String
    },
    labelWidth: {
      type: Number
    },
    width: {
      type: [Number, String],
      default() {
        return 160
      }
    },
    placeholder: {
      type: String,
      default() {
        return '全部'
      }
    },
    game: {
      type: Boolean
    },
    ptom: {
      type: Boolean
    },
    member: {
      type: Boolean
    },
    media: {
      type: Boolean
    },
    group: {
      type: Boolean
    },
    account: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    labels: {
      type: Boolean
    },
    size: {
      type: String
    },
    defaultOption: {
      type: [Number, String],
      default() {
        return ''
      }
    }
  },
  methods: {
    sendEvent(meta) {
      if (meta.length) meta = meta.pop()
      else meta = ''
      this.$emit('on-change', meta)
    },
    handleEvent(meta) {
      this.game && (this.gameId = meta.id)
      this.ptom && (this.ptomId = meta.id)
      this.member && (this.opId = meta.id)
      this.media && (this.mediaId = meta.id)
      this.group && (this.groupId = meta.id)
      this.account && (this.accountId = meta.id)
    },
    preloadData() {
      const promise = []
      this.game && promise.push(adGames())
      this.ptom && promise.push(adPtom({ authFlag: 1 }))
      this.member && promise.push(getCaoHuaOpenIds())
      this.media && promise.push(getSysMedia())
      this.group && promise.push(getPtomGroupGames())
      this.account && promise.push(adAccount({ authFlag: 1 }))
      this.labels && promise.push(getSysTag())
      Promise.all(promise).then((data) => {
        const [promiseData] = data
        if (isArray(promiseData) && this.game) this.gameData = promiseData
        else if (isArray(promiseData) && this.member) this.opData = promiseData
        else if (isArray(promiseData) && this.ptom) this.ptomData = promiseData
        else if (isArray(promiseData) && this.account) this.accountData = promiseData
        else if (isArray(promiseData) && this.media) {
          this.mediaData = promiseData.map((ret) => {
            return {
              id: ret.mediaId,
              name: ret.mediaName
            }
          })
        } else if (isArray(promiseData) && this.group) {
          this.groupData = promiseData.map((ret) => {
            return {
              id: ret.groupId,
              name: ret.groupName,
              children: ret.gameIds
            }
          })
        } else if (isArray(promiseData) && this.labels) {
          this.labelData = promiseData.map((ret) => {
            return {
              id: ret.labelId,
              name: ret.content
            }
          })
        }
        this.defaultOption && this.bindDefautOption()
      })
    },
    bindDefautOption() {
      const defaultOption =
        typeof this.defaultOption === 'string' && this.defaultOption.includes(',')
          ? this.defaultOption.split(',').map((ret) => Number(ret))
          : this.defaultOption && Number(this.defaultOption)
      const arrDefOption = isArray(defaultOption) ? defaultOption : [defaultOption]
      this.game && (this.gameId = this.value || defaultOption)
      this.ptom && (this.ptomId = this.value || defaultOption)
      this.member && (this.opId = this.value || defaultOption)
      this.media && (this.mediaId = this.value || defaultOption)
      this.group && (this.groupId = this.value || defaultOption)
      this.account && (this.accountId = this.value || defaultOption)
      this.labels && (this.labelIds = this.value || arrDefOption)
    }
  },
  watch: {
    gameId(nVal) {
      const meta = this.gameData.filter((ret) => ret.id === nVal)
      this.game && this.$emit('input', nVal)
      this.sendEvent(meta)
      // debounce(() => { this.sendEvent(meta) }, 500)()
    },
    ptomId(nVal) {
      const meta = this.ptomData.filter((ret) => ret.id === nVal)
      this.ptom && this.$emit('input', nVal)
      this.sendEvent(meta)
      // debounce(() => { this.sendEvent(meta) }, 500)()
    },
    opId(nVal) {
      const meta = this.opData.filter((ret) => ret.id === nVal)
      this.member && this.$emit('input', nVal)
      this.sendEvent(meta)
      // debounce(() => { this.sendEvent(meta) }, 500)()
    },
    mediaId(nVal) {
      const meta = this.mediaData.filter((ret) => ret.id === nVal)
      this.media && this.$emit('input', nVal)
      this.sendEvent(meta)
      // debounce(() => { this.sendEvent(meta) }, 500)()
    },
    groupId(nVal) {
      const meta = this.groupData.filter((ret) => ret.id === nVal)
      this.group && this.$emit('input', nVal)
      this.sendEvent(meta)
      // debounce(() => { this.sendEvent(meta) }, 500)()
    },
    accountId(nVal) {
      const meta = this.accountData.filter((ret) => ret.id === nVal)
      this.account && this.$emit('input', nVal)
      this.sendEvent(meta)
      // debounce(() => { this.sendEvent(meta) }, 500)()
    },
    labelIds(nVal) {
      this.labels && this.$emit('input', nVal)
      this.$emit('on-change', nVal)
      // debounce(() => { this.$emit('on-change', nVal) }, 500)()
      // this.$refs.multSelect.blur()
    },
    value(nVal) {
      this.bindDefautOption()
    }
  },
  data() {
    return {
      mediaId: '',
      mediaData: [],
      opId: '',
      opData: [],
      gameId: '',
      gameData: [],
      groupId: '',
      groupData: [],
      ptomId: '',
      ptomData: [],
      accountId: '',
      accountData: [],
      labelIds: [],
      labelData: []
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-input {
  .el-input__inner:not(.el-input--mini .el-input__inner),
  .el-input__icon {
    height: 32px !important;
    line-height: 32px !important;
  }
}

::v-deep .el-select__tags {
  max-width: 100% !important;
}

::v-deep .el-select__tags-text {
  max-width: 110px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
